export enum UtilizationTab {
  DAILY_USAGE = 'daily-usage',
  COMPARE_MACHINE_GROUPS = 'compare-machine-groups',
}
